import styled from "styled-components";

import { fontSizes } from "../../shared/styles/typography";

export const Body = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const Item = styled.article<{ $read?: boolean }>`
  background: #fff;
  border-radius: 14px;
  padding: 16px;
  border: 1px solid #e8eaf0;
  opacity: ${({ $read }) => ($read ? 0.75 : 1)};
`;

export const ItemTitle = styled.h3`
  font-size: ${fontSizes.base}px;
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-title);
  margin-bottom: 6px;
`;

export const ItemBody = styled.p`
  font-size: ${fontSizes.base}px;
  color: var(--color-text-complement);
  line-height: 1.45;
  margin: 0;
`;

export const ItemMeta = styled.span`
  display: block;
  margin-top: 10px;
  font-size: ${fontSizes.sm}px;
  color: #94a3b8;
`;

export const Empty = styled.div`
  text-align: center;
  padding: 40px 16px;
  color: #64748b;
  font-size: ${fontSizes.sm}px;
`;
